export class NativeStreamSamplingPredicate {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "column",
            "baseName": "column",
            "type": "string",
            "format": ""
        },
        {
            "name": "equals",
            "baseName": "equals",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamSamplingPredicate.attributeTypeMap;
    }
    constructor() {
    }
}
